export default __webpack_public_path__ + "static/media/SWT1440.34I-35684_-20773_0.4b0f0c04.jpg";